import Vue from 'vue';
import CheckIcon from './CheckIcon';
import CheckList from './CheckList';
import ContentCard from './ContentCard';
import ControlButton from './ControlButton';
import DoughnutChart from './DoughnutChart';
import DownloadButton from './DownloadButton';
import DragAndDrop from './DragAndDrop';
import DragAndDrop2 from './DragAndDrop2';
import EvaluationCard from './EvaluationCard';
import FinalSlide from './FinalSlide';
import FlashCards from './FlashCards';
import FlippableCard from './FlippableCard';
import Guide from './Guide';
import Hotspot from './Hotspot';
import InfoBox from './InfoBox';
import Magnifier from './Magnifier';
import Mascot from './Mascot';
import Notebook from './Notebook';
import Modal from './Modal';
import ModuleList from './ModuleList';
import Quiz from './Quiz';
import RevealAccordions from './RevealAccordions';
import ScrollBarX from './ScrollBarX';
import SlideInTransition from './SlideInTransition';
import SortingPuzzle from './SortingPuzzle';
import SpeechBubble from './SpeechBubble';
import TextBox from './TextBox';
import ThoughtBubble from './ThoughtBubble';
import TimeSlider from './TimeSlider';
import Tinder from './Tinder';
import VideoElement from './VideoElement';
import ZoomImage from './ZoomImage';

const components = {
    CheckIcon,
    CheckList,
    ContentCard,
    ControlButton,
    DoughnutChart,
    DownloadButton,
    DragAndDrop,
    DragAndDrop2,
    EvaluationCard,
    FinalSlide,
    FlashCards,
    FlippableCard,
    Guide,
    Hotspot,
    InfoBox,
    Magnifier,
    Mascot,
    Modal,
    ModuleList,
    Notebook,
    Quiz,
    RevealAccordions,
    ScrollBarX,
    SlideInTransition,
    SortingPuzzle,
    SpeechBubble,
    TextBox,
    ThoughtBubble,
    TimeSlider,
    Tinder,
    VideoElement,
    ZoomImage
};

Object
    .entries(components)
    .forEach(
        ([name, component]) => Vue.component(name, component)
    );
